"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedPriceOracle__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "admin",
                type: "address",
            },
            {
                internalType: "address",
                name: "nativeMarket_",
                type: "address",
            },
            {
                internalType: "address",
                name: "nativeAsset_",
                type: "address",
            },
            {
                internalType: "contract IPyth",
                name: "pythOracle_",
                type: "address",
            },
            {
                internalType: "contract IPendlePtOracle",
                name: "pendlePtOracle_",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "EmptyAdapterAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "EmptyFeedAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "EmptyMaxStalePeriod",
        type: "error",
    },
    {
        inputs: [],
        name: "EmptyPendlePtOracle",
        type: "error",
    },
    {
        inputs: [],
        name: "EmptyPythOracle",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidDecimals",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidFeedDecimals",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidPrice",
        type: "error",
    },
    {
        inputs: [],
        name: "UnknownSource",
        type: "error",
    },
    {
        inputs: [],
        name: "UnsupportedSource",
        type: "error",
    },
    {
        inputs: [],
        name: "ZeroAddressNotAllowed",
        type: "error",
    },
    {
        inputs: [],
        name: "ZeroValueNotAllowed",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "asset",
                type: "address",
            },
            {
                indexed: false,
                internalType: "enum FeedPriceOracle.Source",
                name: "source",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "feedDecimals",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "maxStalePeriod",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "metadata",
                type: "bytes32",
            },
        ],
        name: "NewFeed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldValue",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newValue",
                type: "address",
            },
        ],
        name: "NewPendlePtOracle",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldValue",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newValue",
                type: "address",
            },
        ],
        name: "NewPythOracle",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferStarted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "acceptOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "adapterFeeds",
        outputs: [
            {
                internalType: "address",
                name: "adapterAddr",
                type: "address",
            },
            {
                internalType: "address",
                name: "denominator",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "chainlinkFeeds",
        outputs: [
            {
                internalType: "address",
                name: "feedAddr",
                type: "address",
            },
            {
                internalType: "address",
                name: "denominator",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "feedDecimals",
                type: "uint8",
            },
            {
                internalType: "uint32",
                name: "maxStalePeriod",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "fixedPrices",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
        ],
        name: "getFixedPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
        ],
        name: "getPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "ctoken",
                type: "address",
            },
        ],
        name: "getUnderlyingPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "cTokens",
                type: "address[]",
            },
        ],
        name: "getUnderlyingPrices",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isPriceOracle",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "layerbankFeeds",
        outputs: [
            {
                internalType: "address",
                name: "feedAddr",
                type: "address",
            },
            {
                internalType: "address",
                name: "feedAssetAddr",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "mainSource",
        outputs: [
            {
                internalType: "enum FeedPriceOracle.Source",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nativeAsset",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nativeMarket",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingOwner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "pendleFeeds",
        outputs: [
            {
                internalType: "address",
                name: "market",
                type: "address",
            },
            {
                internalType: "address",
                name: "yieldToken",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "twapDuration",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendlePtOracle",
        outputs: [
            {
                internalType: "contract IPendlePtOracle",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "pythFeeds",
        outputs: [
            {
                internalType: "bytes32",
                name: "feedId",
                type: "bytes32",
            },
            {
                internalType: "uint32",
                name: "maxStalePeriod",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "denominator",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pythOracle",
        outputs: [
            {
                internalType: "contract IPyth",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "redstoneFeeds",
        outputs: [
            {
                internalType: "address",
                name: "feedAddr",
                type: "address",
            },
            {
                internalType: "address",
                name: "denominator",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "feedDecimals",
                type: "uint8",
            },
            {
                internalType: "uint32",
                name: "maxStalePeriod",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
        ],
        name: "removeAdapterFeed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
        ],
        name: "removeBalancerFeed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
        ],
        name: "removeChainlinkFeed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
        ],
        name: "removeFixedPrice",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
        ],
        name: "removeKodiakIslandFeed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
        ],
        name: "removeLayerbankFeed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
        ],
        name: "removePendleFeed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
        ],
        name: "removePythFeed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
        ],
        name: "removeRedstoneFeed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
        ],
        name: "removeUniswapV2Feed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
            {
                internalType: "address",
                name: "adapterAddr",
                type: "address",
            },
            {
                internalType: "address",
                name: "denominator",
                type: "address",
            },
        ],
        name: "setAdapterFeed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
        ],
        name: "setBalancerFeed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
            {
                internalType: "address",
                name: "feedAddr",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "maxStalePeriod",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "denominator",
                type: "address",
            },
        ],
        name: "setChainlinkFeed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
        ],
        name: "setFixedPrice",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
        ],
        name: "setKodiakIslandFeed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
            {
                internalType: "address",
                name: "feedAddr",
                type: "address",
            },
            {
                internalType: "address",
                name: "feedAssetAddr",
                type: "address",
            },
        ],
        name: "setLayerbankFeed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
            {
                internalType: "enum FeedPriceOracle.Source",
                name: "source",
                type: "uint8",
            },
        ],
        name: "setMainSource",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
            {
                internalType: "address",
                name: "market",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "twapDuration",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "yieldToken",
                type: "address",
            },
        ],
        name: "setPendleFeed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IPendlePtOracle",
                name: "pendlePtOracle_",
                type: "address",
            },
        ],
        name: "setPendlePtOracle",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "maxStalePeriod",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "feedId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "denominator",
                type: "address",
            },
        ],
        name: "setPythFeed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IPyth",
                name: "pythOracle_",
                type: "address",
            },
        ],
        name: "setPythOracle",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
            {
                internalType: "address",
                name: "feedAddr",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "maxStalePeriod",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "denominator",
                type: "address",
            },
        ],
        name: "setRedStoneFeed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "asset",
                type: "address",
            },
        ],
        name: "setUniswapV2Feed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x60c03461018d57601f61386c38819003918201601f19168301916001600160401b038311848410176101925780849260a09460405283398101031261018d57610047816101a8565b610053602083016101a8565b91610060604082016101a8565b606082015190916001600160a01b0382169182900361018d57608001516001600160a01b038116929083900361018d576100da9461009d336101bc565b600280546001600160a01b0319168417905560805260a0528061014b575b50600380546001600160a01b0319168217905580610109575b506101bc565b60405161365a90816102128239608051818181610d4d0152612419015260a051818181610f0401526124460152f35b60408051600081526001600160a01b039290921660208301527f5319cc71743c0c7ca8781c1b40ef83f7a50ae1c8717ae289061ae6fe14ec731791a1386100d4565b60408051600081526001600160a01b039290921660208301527f19759d4eb479000045508ecc531a909fc19cef338489a548665eb7208d5b008691a1386100bb565b600080fd5b634e487b7160e01b600052604160045260246000fd5b51906001600160a01b038216820361018d57565b600180546001600160a01b0319908116909155600080546001600160a01b03938416928116831782559192909116907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09080a356fe608080604052600436101561001357600080fd5b60003560e01c9081630c1502eb14611e35575080631063169414611dd4578063107c2c2114611bc357806310a4fbcf14611b085780631badc89a14611a7f5780631e922ea614611a2457806322066f99146118be5780632fad2c841461173657806340da82fb146113be578063411509711461120757806341976e09146111e4578063487c2b591461118357806348a1371b14611044578063622bd11814610fb457806366331bba14610f98578063715018a614610f3357806374d32ad414610eee57806379ba509714610e235780637b24f95014610ddd57806383dd966514610d7c5780638a2f7f6d14610d375780638c93fa0914610afa5780638da5cb5b14610ad1578063a1c6058614610a5a578063a868f96714610a0c578063a88bc222146109b6578063b735acf81461095b578063b7df82981461090d578063ba3d2298146108bf578063bd3475cb14610869578063c0749cac14610740578063c2fc9613146106eb578063c5b7ee171461068a578063c5c8bca014610627578063da0fdde2146105ca578063daa666dd146105a1578063e30c397814610578578063e8c1650014610501578063e983fe25146104c7578063ef63aac814610436578063f1feb9791461036a578063f2fde38b146102f6578063f5d6ac90146102cd578063fc57d4df146102a25763ffbc01a81461020e57600080fd5b3461029d57602036600319011261029d57610227611e6b565b61022f6124e5565b6001600160a01b03166000818152600660209081526040808320838155600101839055600a90915290205460ff16600b8110156102875760031461026f57005b6000908152600a60205260409020805460ff19169055005b634e487b7160e01b600052602160045260246000fd5b600080fd5b3461029d57602036600319011261029d5760206102c56102c0611e6b565b612408565b604051908152f35b3461029d57600036600319011261029d576002546040516001600160a01b039091168152602090f35b3461029d57602036600319011261029d5761030f611e6b565b6103176124e5565b60018060a01b0316806bffffffffffffffffffffffff60a01b600154161760015560018060a01b03600054167f38d16b8cac22d99fc7c124b9cd0de2d3fa1faef420bfe791d8c362d765e22700600080a3005b3461029d57606036600319011261029d57610383611e6b565b61038b611e81565b610393611e97565b9061039c6124e5565b6001600160a01b0316918215610425576103e891604051936103bd85611f08565b845260018060a01b0316602084015260018060a01b031691826000526009602052604060002061201f565b80600052600a60205260ff60406000205416600b811015610287571561040a57005b6000908152600a60205260409020805460ff19166006179055005b630d7e65e760e41b60005260046000fd5b3461029d57602036600319011261029d576004356001600160a01b0381169081900361029d577f5319cc71743c0c7ca8781c1b40ef83f7a50ae1c8717ae289061ae6fe14ec7317906104866124e5565b6003546104928261253d565b6001600160a01b031981168217600355604080516001600160a01b03928316815291909216602082015290819081015b0390a1005b3461029d57602036600319011261029d576001600160a01b036104e8611e6b565b1660005260086020526020604060002054604051908152f35b3461029d57602036600319011261029d576001600160a01b03610522611e6b565b16600090815260046020908152604091829020805460019091015483516001600160a01b0392831681529181169282019290925260a082901c60ff169281019290925260a81c63ffffffff166060820152608090f35b3461029d57600036600319011261029d576001546040516001600160a01b039091168152602090f35b3461029d57600036600319011261029d576003546040516001600160a01b039091168152602090f35b3461029d57602036600319011261029d576001600160a01b036105eb611e6b565b166000526006602052606060406000206001815491015460405191825263ffffffff8116602083015260018060a01b039060201c166040820152f35b3461029d57602036600319011261029d576001600160a01b03610648611e6b565b1660005260076020526060604060002063ffffffff6001808060a01b0383541692015460405192835260018060a01b038116602084015260a01c166040820152f35b3461029d57602036600319011261029d576106a3611e6b565b6106ab6124e5565b6001600160a01b03166000818152600b60208181526040808420848155600101849055600a9091529091205460ff16908110156102875760071461026f57005b3461029d57604036600319011261029d57610704611e6b565b60243590600b82101561029d576107196124e5565b60018060a01b0316600052600a60205260406000209060ff80198354169116179055600080f35b3461029d57608036600319011261029d57610759611e6b565b60243563ffffffff811680910361029d576064356001600160a01b0381169081900361029d576107876124e5565b6002546001600160a01b0316156108585781156108475763ffffffff6001604051946107b286611f56565b60443586526020860194855260408601938452818060a01b03169485600052600660205260406000209051815501925116825491640100000000600160c01b03905160201b169167ffffffffffffffff60c01b161717905580600052600a60205260ff60406000205416600b811015610287571561082c57005b6000908152600a60205260409020805460ff19166003179055005b63061624df60e01b60005260046000fd5b632ea45acf60e01b60005260046000fd5b3461029d57602036600319011261029d576001600160a01b0361088a611e6b565b16600090815260096020908152604091829020805460019091015483516001600160a01b039283168152911691810191909152f35b3461029d57602036600319011261029d576108d8611e6b565b6108e06124e5565b6001600160a01b03166000818152600a602052604090205460ff16600b8110156102875760081461026f57005b3461029d57602036600319011261029d57610926611e6b565b61092e6124e5565b6001600160a01b03166000818152600a602052604090205460ff16600b8110156102875760091461026f57005b3461029d57602036600319011261029d57610974611e6b565b61097c6124e5565b6001600160a01b03166000818152600860209081526040808320839055600a90915290205460ff16600b8110156102875760061461026f57005b3461029d57602036600319011261029d576001600160a01b036109d7611e6b565b166000908152600b6020908152604091829020805460019091015483516001600160a01b039283168152911691810191909152f35b3461029d57602036600319011261029d57610a25611e6b565b610a2d6124e5565b6001600160a01b03166000818152600a602052604090205460ff16600b81101561028757600a1461026f57005b3461029d57602036600319011261029d576001600160a01b03610a7b611e6b565b16600090815260056020908152604091829020805460019091015483516001600160a01b0392831681529181169282019290925260a082901c60ff169281019290925260a81c63ffffffff166060820152608090f35b3461029d57600036600319011261029d576000546040516001600160a01b039091168152602090f35b3461029d57602036600319011261029d57610b13611e6b565b610b1b6124e5565b604051630dfe168160e01b81526001600160a01b039190911690602081600481855afa8015610c4e57610d00575b5060405163d21220a760e01b8152602081600481855afa8015610c4e57610cc9575b5060405163313ce56760e01b8152602081600481855afa908115610c4e5760129160ff91600091610c9a575b501611610c89576040516318160ddd60e01b8152602081600481855afa8015610c4e57610c5a575b50604051630240bc6b60e21b8152606081600481855afa8015610c4e57610c1f575b5080600052600a60205260ff60406000205416600b8110156102875715610c0457005b6000908152600a60205260409020805460ff19166009179055005b610c409060603d606011610c47575b610c388183611f72565b8101906123d2565b5050610be1565b503d610c2e565b6040513d6000823e3d90fd5b6020813d602011610c81575b81610c7360209383611f72565b8101031261029d5751610bbf565b3d9150610c66565b630692acc560e51b60005260046000fd5b610cbc915060203d602011610cc2575b610cb48183611f72565b810190611fe1565b84610b97565b503d610caa565b6020813d602011610cf8575b81610ce260209383611f72565b8101031261029d57610cf390611fb6565b610b6b565b3d9150610cd5565b6020813d602011610d2f575b81610d1960209383611f72565b8101031261029d57610d2a90611fb6565b610b49565b3d9150610d0c565b3461029d57600036600319011261029d576040517f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03168152602090f35b3461029d57602036600319011261029d57610d95611e6b565b610d9d6124e5565b6001600160a01b03166000818152600760209081526040808320838155600101839055600a90915290205460ff16600b8110156102875760041461026f57005b3461029d57602036600319011261029d576001600160a01b03610dfe611e6b565b16600052600a60205260ff60406000205416604051600b821015610287576020918152f35b3461029d57600036600319011261029d57600154336001600160a01b0390911603610e9757600180546001600160a01b03199081169091556000805433928116831782556001600160a01b0316907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09080a3005b60405162461bcd60e51b815260206004820152602960248201527f4f776e61626c6532537465703a2063616c6c6572206973206e6f7420746865206044820152683732bb9037bbb732b960b91b6064820152608490fd5b3461029d57600036600319011261029d576040517f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03168152602090f35b3461029d57600036600319011261029d57610f4c6124e5565b600180546001600160a01b0319908116909155600080549182168155906001600160a01b03167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e08280a3005b3461029d57600036600319011261029d57602060405160018152f35b3461029d57602036600319011261029d576004356001600160a01b0381169081900361029d577f19759d4eb479000045508ecc531a909fc19cef338489a548665eb7208d5b0086906110046124e5565b6002546110108261253d565b6001600160a01b031981168217600255604080516001600160a01b03928316815291909216602082015290819081016104c2565b3461029d57602036600319011261029d5760043567ffffffffffffffff811161029d573660238201121561029d57806004013561108081611f94565b9161108e6040519384611f72565b8183526024602084019260051b8201019036821161029d57602401915b818310611163578351846110be82611f94565b916110cc6040519384611f72565b8083526110d881611f94565b602084019290601f190136843760005b8281106111345783856040519182916020830190602084525180915260408301919060005b81811061111b575050500390f35b825184528594506020938401939092019160010161110d565b8061115261114460019385612394565b838060a01b03905116612408565b61115c8288612394565b52016110e8565b82356001600160a01b038116810361029d578152602092830192016110ab565b3461029d57602036600319011261029d5761119c611e6b565b6111a46124e5565b6001600160a01b03166000818152600560209081526040808320838155600101839055600a90915290205460ff16600b8110156102875760021461026f57005b3461029d57602036600319011261029d5760206102c5611202611e6b565b612142565b3461029d57602036600319011261029d57611220611e6b565b6112286124e5565b6040516311b2515f60e31b81526001600160a01b039190911690602081600481855afa8015610c4e57611387575b5060405163038fff2d60e41b8152602081600481855afa8015610c4e57611358575b5060405163313ce56760e01b8152602081600481855afa908115610c4e5760129160ff91600091611339575b501611610c89576040516318160ddd60e01b8152602081600481855afa8015610c4e5761130a575b5080600052600a60205260ff60406000205416600b81101561028757156112ef57005b6000908152600a60205260409020805460ff19166008179055005b6020813d602011611331575b8161132360209383611f72565b8101031261029d57516112cc565b3d9150611316565b611352915060203d602011610cc257610cb48183611f72565b846112a4565b6020813d60201161137f575b8161137160209383611f72565b8101031261029d5751611278565b3d9150611364565b6020813d6020116113b6575b816113a060209383611f72565b8101031261029d576113b190611fb6565b611256565b3d9150611393565b3461029d576113cc36611ead565b9291906113d76124e5565b6003546001600160a01b0316156117255763ffffffff906113f78361253d565b6114008561253d565b1690811561171457604051630b2339af60e21b8152936001600160a01b039190911690606085600481855afa8015610c4e57600095869161169d575b506001600160a01b039485169594169384860361166a5760206004956040519687809263afd27bf560e01b82525afa948515610c4e5760009561162e575b506001600160a01b0390811694168490036115fb576020600494604051958680926376d5de8560e01b82525afa938415610c4e576000946115bf575b506001600160a01b039081169316839003611584576040516001916114da82611f56565b815260208082019485526040808301948552600087815260078352818120935184546001600160a01b03191660a087811b88900392909216178555965194909301805495516001600160c01b03199096166001600160a01b0395909516949094179490951b63ffffffff60a01b1693909317909155600a909152205460ff16600b811015610287571561156957005b6000908152600a60205260409020805460ff19166004179055005b60405162461bcd60e51b81526020600482015260136024820152720f2d2cad8c8a8ded6cadc40dad2e6dac2e8c6d606b1b6044820152606490fd5b9093506020813d6020116115f3575b816115db60209383611f72565b8101031261029d576115ec90611fb6565b92856114b6565b3d91506115ce565b60405162461bcd60e51b815260206004820152600b60248201526a0e6f240dad2e6dac2e8c6d60ab1b6044820152606490fd5b9094506020813d602011611662575b8161164a60209383611f72565b8101031261029d5761165b90611fb6565b938661147a565b3d915061163d565b60405162461bcd60e51b815260206004820152600b60248201526a0e0e840dad2e6dac2e8c6d60ab1b6044820152606490fd5b9590506060863d60601161170c575b816116b960609383611f72565b81010312611705578551906001600160a01b0382168203611705576020870151966001600160a01b038816880361170857604001516001600160a01b038116036117055750948661143c565b80fd5b5080fd5b3d91506116ac565b63273e150360e21b60005260046000fd5b637590f92f60e01b60005260046000fd5b3461029d5761174436611ead565b916117509391936124e5565b60405163313ce56760e01b81526001600160a01b03919091169390602081600481885afa908115610c4e5760009161189f575b50841561188e5760ff1690811561187d5763ffffffff1691821561084757600190604051956117b187611f3a565b865260a082811b83900395861660208089019182526040808a0196875260608a019788529388166000818152600483528581209a518b546001600160a01b0319169a16999099178a559151989094018054955196516001600160c81b03199096166001600160a01b0399909916989098179590911b60ff60a01b169490941760a89390931b63ffffffff60a81b1692909217909455600a9093529190205460ff16600b811015610287571561186257005b6000908152600a60205260409020805460ff19166001179055005b63da0623a160e01b60005260046000fd5b6346d684a560e11b60005260046000fd5b6118b8915060203d602011610cc257610cb48183611f72565b85611783565b3461029d576118cc36611ead565b916118d89391936124e5565b60405163313ce56760e01b81526001600160a01b03919091169390602081600481885afa908115610c4e57600091611a05575b50841561188e5760ff1690811561187d5763ffffffff16918215610847576001906040519561193987611f3a565b865260a082811b83900395861660208089019182526040808a0196875260608a019788529388166000818152600583528581209a518b546001600160a01b0319169a16999099178a559151989094018054955196516001600160c81b03199096166001600160a01b0399909916989098179590911b60ff60a01b169490941760a89390931b63ffffffff60a81b1692909217909455600a9093529190205460ff16600b81101561028757156119ea57005b6000908152600a60205260409020805460ff19166002179055005b611a1e915060203d602011610cc257610cb48183611f72565b8561190b565b3461029d57602036600319011261029d57611a3d611e6b565b611a456124e5565b6001600160a01b03166000818152600860209081526040808320839055600a90915290205460ff16600b8110156102875760051461026f57005b3461029d57604036600319011261029d57611a98611e6b565b60243590611aa46124e5565b611aad8161253d565b81156117145760018060a01b03169081600052600860205260406000205580600052600a60205260ff60406000205416600b8110156102875715611aed57005b6000908152600a60205260409020805460ff19166005179055005b3461029d57606036600319011261029d57611b21611e6b565b611b29611e81565b611b31611e97565b90611b3a6124e5565b6001600160a01b031691821561188e57611b869160405193611b5b85611f08565b845260018060a01b0316602084015260018060a01b03169182600052600b602052604060002061201f565b80600052600a60205260ff60406000205416600b8110156102875715611ba857005b6000908152600a60205260409020805460ff19166007179055005b3461029d57602036600319011261029d57611bdc611e6b565b611be46124e5565b604051630dfe168160e01b81526001600160a01b039190911690602081600481855afa8015610c4e57611d9d575b5060405163d21220a760e01b8152602081600481855afa8015610c4e57611d66575b5060405163313ce56760e01b8152602081600481855afa908115610c4e5760129160ff91600091611d47575b501611610c89576040516318160ddd60e01b8152602081600481855afa8015610c4e57611d18575b50604080516304c8b65560e21b81529081600481855afa8015610c4e57611cea575b5080600052600a60205260ff60406000205416600b8110156102875715611ccd57005b600052600a6020526040600020600a60ff19825416179055600080f35b611d0b9060403d604011611d11575b611d038183611f72565b810190612009565b50611caa565b503d611cf9565b6020813d602011611d3f575b81611d3160209383611f72565b8101031261029d5751611c88565b3d9150611d24565b611d60915060203d602011610cc257610cb48183611f72565b84611c60565b6020813d602011611d95575b81611d7f60209383611f72565b8101031261029d57611d9090611fb6565b611c34565b3d9150611d72565b6020813d602011611dcc575b81611db660209383611f72565b8101031261029d57611dc790611fb6565b611c12565b3d9150611da9565b3461029d57602036600319011261029d57611ded611e6b565b611df56124e5565b6001600160a01b03166000818152600460209081526040808320838155600101839055600a90915290205460ff16600b8110156102875760011461026f57005b3461029d57602036600319011261029d576020906001600160a01b03611e59611e6b565b16600052600882526040600020548152f35b600435906001600160a01b038216820361029d57565b602435906001600160a01b038216820361029d57565b604435906001600160a01b038216820361029d57565b608090600319011261029d576004356001600160a01b038116810361029d57906024356001600160a01b038116810361029d579060443563ffffffff8116810361029d57906064356001600160a01b038116810361029d5790565b6040810190811067ffffffffffffffff821117611f2457604052565b634e487b7160e01b600052604160045260246000fd5b6080810190811067ffffffffffffffff821117611f2457604052565b6060810190811067ffffffffffffffff821117611f2457604052565b90601f8019910116810190811067ffffffffffffffff821117611f2457604052565b67ffffffffffffffff8111611f245760051b60200190565b600b111561028757565b51906001600160a01b038216820361029d57565b9081602091031261029d57611fde90611fb6565b90565b9081602091031261029d575160ff8116810361029d5790565b9081602091031261029d575190565b919082604091031261029d576020825192015190565b815181546001600160a01b03199081166001600160a01b03928316178355602090930151600190920180549093169116179055565b9060405161206181611f08565b82546001600160a01b0390811682526001909301549092166020830152565b9060405161208d81611f56565b82546001600160a01b03908116825260019390930154928316602082015260a09290921c63ffffffff166040830152565b906040516120cb81611f56565b825481526001929092015463ffffffff81166020808501919091521c6001600160a01b03166040830152565b9060405161210481611f3a565b82546001600160a01b03908116825260019390930154928316602082015260a083901c60ff16604082015260a89290921c63ffffffff166060830152565b6001600160a01b0381166000908152600a602052604090205460ff1661216781611fac565b80156123835760009061217981611fac565b600181036121c55750506001600160a01b031660009081526004602052604090206121ac906121a7906120f7565b613403565b80156121b55790565b62bfc92160e01b60005260046000fd5b6121ce81611fac565b600281036122015750506001600160a01b031660009081526005602052604090206121fc906121a7906120f7565b6121ac565b61220a81611fac565b6003810361223d5750506001600160a01b031660009081526006602052604090206121fc90612238906120be565b613297565b61224681611fac565b600481036122795750506001600160a01b031660009081526007602052604090206121fc9061227490612080565b613097565b61228281611fac565b600581036122a95750506001600160a01b03166000908152600860205260409020546121ac565b6122b281611fac565b600681036122e55750506001600160a01b031660009081526009602052604090206121fc906122e090612054565b613001565b6122ee81611fac565b600781036123215750506001600160a01b03166000908152600b602052604090206121fc9061231c90612054565b612f8f565b61232a81611fac565b6008810361233d5750506121fc90612c94565b61234681611fac565b600981036123595750506121fc90612902565b80612365600a92611fac565b0361237457506121fc90612631565b6379b7ef0d60e01b8152600490fd5b632416b03b60e11b60005260046000fd5b80518210156123a85760209160051b010190565b634e487b7160e01b600052603260045260246000fd5b51906001600160701b038216820361029d57565b9081606091031261029d576123e6816123be565b9160406123f5602084016123be565b92015163ffffffff8116810361029d5790565b6001600160a01b03908116906000907f000000000000000000000000000000000000000000000000000000000000000016820361246a575050611fde7f0000000000000000000000000000000000000000000000000000000000000000612142565b602060049260405193848092636f307dc360e01b82525afa9081156124d957809161249b575b50611fde9150612142565b90506020823d6020116124d1575b816124b660209383611f72565b8101031261170557506124cb611fde91611fb6565b38612490565b3d91506124a9565b604051903d90823e3d90fd5b6000546001600160a01b031633036124f957565b606460405162461bcd60e51b815260206004820152602060248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152fd5b6001600160a01b03161561254d57565b6342bcdf7f60e11b60005260046000fd5b1561256557565b60405162461bcd60e51b815260206004820152602660248201527f546f74616c20737570706c79206d7573742062652067726561746572207468616044820152656e207a65726f60d01b6064820152608490fd5b818102929181159184041417156125cc57565b634e487b7160e01b600052601160045260246000fd5b60ff166012039060ff82116125cc57565b60ff16604d81116125cc57600a0a90565b919082018092116125cc57565b811561261b570490565b634e487b7160e01b600052601260045260246000fd5b604080516304c8b65560e21b8152916001600160a01b03169082600481845afa918215612815576000906000936128de575b506040516318160ddd60e01b8152602081600481865afa908115612815576000916128af575b50604051630dfe168160e01b815291602083600481875afa9283156128155760009361288e575b5060405163d21220a760e01b815293602085600481845afa9081156128155760049560009261285c575b506020906040519687809263313ce56760e01b82525afa9485156128155760009561283b575b5060405163313ce56760e01b8152906020826004816001600160a01b0389165afa9182156128155760009261281a575b5060405163313ce56760e01b8152946020866004816001600160a01b0386165afa958615612815576000966127f0575b5061276a90612142565b6127749091612142565b811580156127e8575b6121b5576127d66127e2966127ca6127c56127bf611fde9c6127d06127c5996127ca6127c56127bf8f9e6127ca9f9d6127ba6127dc9f151561255e565b6125b9565b926125e2565b6125f3565b906125b9565b966125b9565b90612604565b946125e2565b90612611565b50801561277d565b61276a91965061280e9060203d602011610cc257610cb48183611f72565b9590612760565b610c4e565b61283491925060203d602011610cc257610cb48183611f72565b9038612730565b61285591955060203d602011610cc257610cb48183611f72565b9338612700565b602091925061288090823d8411612887575b6128788183611f72565b810190611fca565b91906126da565b503d61286e565b6128a891935060203d602011612887576128788183611f72565b91386126b0565b6128d1915060203d6020116128d7575b6128c98183611f72565b810190611ffa565b38612689565b503d6128bf565b90506128fa91925060403d604011611d1157611d038183611f72565b919038612663565b604051630240bc6b60e21b8152906001600160a01b0316606082600481845afa91821561281557600090600093612b73575b506040516318160ddd60e01b8152602081600481865afa90811561281557600091612b54575b50604051630dfe168160e01b815291602083600481875afa92831561281557600093612b33575b5060405163d21220a760e01b815293602085600481845afa90811561281557600495600092612b11575b506020906040519687809263313ce56760e01b82525afa94851561281557600095612af0575b5060405163313ce56760e01b81526020816004816001600160a01b0389165afa90811561281557600091612ad1575b5060405163313ce56760e01b8152946020866004816001600160a01b0387165afa95861561281557600096612aac575b50612a3a90612142565b612a449092612142565b9682158015612aa4575b6121b5576127d66127e2966127ca6127c56127bf611fde9c6001600160701b03612a9c6127dc996127ca6127c58f6127ca9f9e6127c59f8790612a956127bf94151561255e565b16906125b9565b9716906125b9565b508715612a4e565b612a3a919650612aca9060203d602011610cc257610cb48183611f72565b9590612a30565b612aea915060203d602011610cc257610cb48183611f72565b38612a00565b612b0a91955060203d602011610cc257610cb48183611f72565b93386129d1565b6020919250612b2c90823d8411612887576128788183611f72565b91906129ab565b612b4d91935060203d602011612887576128788183611f72565b9138612981565b612b6d915060203d6020116128d7576128c98183611f72565b3861295a565b9050612b8f91925060603d606011610c4757610c388183611f72565b50919038612934565b909160608284031261029d57815167ffffffffffffffff811161029d57820183601f8201121561029d57805190612bce82611f94565b91612bdc6040519384611f72565b80835260208084019160051b8301019186831161029d57602001905b828210612c7c5750505092602083015167ffffffffffffffff811161029d5783019080601f8301121561029d578151612c3081611f94565b92612c3e6040519485611f72565b81845260208085019260051b82010192831161029d57602001905b828210612c6c5750505060409092015190565b8151815260209182019101612c59565b60208091612c8984611fb6565b815201910190612bf8565b6040516311b2515f60e31b81526001600160a01b039190911690602081600481855afa801561281557612cd891600091612f70575b506001600160a01b03166135ab565b6040516311b2515f60e31b815290602082600481845afa91821561281557600092612f4f575b5060405163038fff2d60e41b815292602084600481855afa93841561281557600094612f2e575b5060405163313ce56760e01b8152602081600481865afa90811561281557600091612f0f575b5060405163876f303b60e01b815294602086600481875afa95861561281557612daa96600093612d89928592612ee6575b506127c56127ca916125e2565b946040518080988194631f29a8cd60e31b8352600483019190602083019252565b03916001600160a01b03165afa93841561281557600090600095612ebd575b50600091825b8251841015612ead57612df2612de58585612394565b516001600160a01b031690565b6001600160a01b0381169190868314612ea257612e0e90612142565b9081156121b55760206004936040519485809263313ce56760e01b82525afa92831561281557600193612e6593888c6127d694600094612e6e575b506127ca92612e5e6127c5936127bf93612394565b51906125b9565b935b0192612dcf565b6127bf91945092612e5e6127c593612e966127ca9660203d8111610cc257610cb48183611f72565b96935093505092612e49565b509360019150612e67565b9250945050611fde929150612611565b9050612edd9194503d806000833e612ed58183611f72565b810190612b98565b50939038612dc9565b6127ca919250612f076127c59160203d6020116128d7576128c98183611f72565b929150612d7c565b612f28915060203d602011610cc257610cb48183611f72565b38612d4b565b612f4891945060203d6020116128d7576128c98183611f72565b9238612d25565b612f6991925060203d602011612887576128788183611f72565b9038612cfe565b612f89915060203d602011612887576128788183611f72565b38612cc9565b805160209182015160405163b95ed06f60e01b81526001600160a01b039182166004820152929183916024918391165afa908115610c4e57600091612fd2575090565b90506020813d602011612ff9575b81612fed60209383611f72565b8101031261029d575190565b3d9150612fe0565b8051604051633ba0b9a960e01b815290602090829060049082906001600160a01b03165afa90811561281557600091613078575b506020919091015181906001600160a01b03168061305257505090565b61305d919250612142565b61306a90611fde926125b9565b670de0b6b3a7640000900490565b613091915060203d6020116128d7576128c98183611f72565b38613035565b6003546130b4906001600160a01b03165b6001600160a01b031690565b906001600160a01b03821615611725578051604080830151905163a31426d160e01b81526001600160a01b03909216600483015263ffffffff16602482015291602090839060449082905afa91821561281557600092613133575b5060200151613126906001600160a01b0316612142565b611fde9161306a916125b9565b613126919250602061315461120292823d84116128d7576128c98183611f72565b9392505061310f565b3d15613198573d9067ffffffffffffffff8211611f24576040519161318c601f8201601f191660200184611f72565b82523d6000602084013e565b606090565b156131a457565b60405162461bcd60e51b815260206004820152600a602482015269383cba341032b93937b960b11b6044820152606490fd5b919082608091031261029d5781518060070b810361029d5791602081015167ffffffffffffffff8116810361029d579160408201518060030b810361029d5760609092015190565b60030b600003908160030b9182036125cc57565b63ffffffff166012039063ffffffff82116125cc57565b1561325057565b60405162461bcd60e51b8152602060048201526011602482015270646563696d616c20756e646572666c6f7760781b6044820152606490fd5b604d81116125cc57600a0a90565b6002546132ac906001600160a01b03166130a8565b6001600160a01b0381161561085857604061339061336967ffffffffffffffff61338961337761336961337261335e60008061339f9b8d61332c61333a6132fc6020845194015163ffffffff1690565b8f5163052571af60e51b60208201908152602482019590955263ffffffff90911660448201529182906064820190565b03601f198101835282611f72565b51915afa61334f61334961315d565b9161319d565b602080825183010191016131d6565b50905096909661321e565b63ffffffff1690565b613232565b6133846012821115613249565b613289565b91166125b9565b9201516001600160a01b031690565b6001600160a01b0381166133b1575090565b61305d90612142565b519069ffffffffffffffffffff8216820361029d57565b908160a091031261029d576133e5816133ba565b91602082015191604081015191611fde6080606084015193016133ba565b8051613417906001600160a01b03166130a8565b600461342d613369606085015163ffffffff1690565b60a061344e613448613443604088015160ff1690565b6125e2565b60ff1690565b9360405193848092633fabe5a360e21b8252600180861b03165afa801561281557600092600091613573575b50600083131561352e578042106134e9574203116134a4576133906020916127ca61339f94613289565b60405162461bcd60e51b815260206004820152601760248201527f636861696e6c696e6b20707269636520657870697265640000000000000000006044820152606490fd5b60405162461bcd60e51b815260206004820152601c60248201527f757064617465644174206578636565647320626c6f636b2074696d65000000006044820152606490fd5b60405162461bcd60e51b815260206004820181905260248201527f636861696e6c696e6b207072696365206d75737420626520706f7369746976656044820152606490fd5b905061359891925060a03d60a0116135a4575b6135908183611f72565b8101906133d1565b5093925050913861347a565b503d613586565b6000809160405160208101906303a38fa160e21b8252836024820152602481526135d6604482611f72565b51916001600160a01b0316612710fa506135ee61315d565b516135f557565b60405162461bcd60e51b81526020600482015260076024820152667265656e74727960c81b6044820152606490fdfea264697066735822122011140a73c88067b158348442c474a3da7a2673a0725a85078e8f51acd7bf251464736f6c634300081a0033";
const isSuperArgs = (xs) => xs.length > 1;
class FeedPriceOracle__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(admin, nativeMarket_, nativeAsset_, pythOracle_, pendlePtOracle_, overrides) {
        return super.getDeployTransaction(admin, nativeMarket_, nativeAsset_, pythOracle_, pendlePtOracle_, overrides || {});
    }
    deploy(admin, nativeMarket_, nativeAsset_, pythOracle_, pendlePtOracle_, overrides) {
        return super.deploy(admin, nativeMarket_, nativeAsset_, pythOracle_, pendlePtOracle_, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.FeedPriceOracle__factory = FeedPriceOracle__factory;
FeedPriceOracle__factory.bytecode = _bytecode;
FeedPriceOracle__factory.abi = _abi;
//# sourceMappingURL=FeedPriceOracle__factory.js.map